export const RENDER_TRANSACTION_TYPE = {
  EMPTY: 'empty',
  EMPTY_PENDING: 'empty_pending',
  EMPTY_TRANSACTION: 'empty_transaction',
  PENDING: 'pending',
  NOT_FOUND: 'not_found',
  FILTER_LOADING: 'filter_loading'
};

export const PAYMENT_STATUS = {
  PENDING: 'pending',
  SENT: 'sent',
  PENDING_REVIEW: 'pending_review',
  REJECTED: 'rejected',
  CLEARING: 'clearing',
  CANCELED: 'canceled',
  RETURNED: 'returned',
  NO_LONGER_LINKED: 'no longer linked'
};

export const EMPTY_PAYMENT_DESCRIPTION = {
  PAYEE: 'You do not have any transaction history with this payee',
  BANK_ACCOUNT: 'You do not have any transaction history with this bank account.',
  DEBIT_CARD: 'You do not have any transaction history'
};

export const TRANSACTION_DIRECTION = {
  DEBIT: 'debit',
  CREDIT: 'credit'
};

export const statusOptions = [
  { key: 'all', name: 'All' },
  { key: PAYMENT_STATUS.PENDING, name: 'Pending' },
  { key: PAYMENT_STATUS.PENDING_REVIEW, name: 'Pending Review' },
  { key: PAYMENT_STATUS.SENT, name: 'Sent' },
  { key: PAYMENT_STATUS.REJECTED, name: 'Rejected' },
  { key: PAYMENT_STATUS.CANCELED, name: 'Canceled' },
  { key: PAYMENT_STATUS.CLEARING, name: 'Clearing' },
  { key: PAYMENT_STATUS.RETURNED, name: 'Returned' }
];

export const statisticsOptions = [
  { key: '30', name: 'Last 30 days' },
  { key: '60', name: 'Last 60 days' },
  { key: '90', name: 'Last 90 days' }
];

export const PAYMENT_LIST_STATUS = {
  LOADING: 'LOADING',
  HAS_PAYMENT: 'HAS_PAYMENT',
  EMPTY: 'EMPTY'
};

export const AUTHORIZATION_TRANSACTION_STATUS = {
  AUTHORIZED: 'authorized',
  COMPLETED: 'completed',
  CANCELED: 'canceled',
  DECLINED: 'declined'
};

export const CHECK_DEPOSIT_STATUS = {
  AWAITING_IMAGES: 'awaiting_images',
  AWAITING_FRONT_IMAGE: 'awaiting_front_image',
  AWAITING_BACK_IMAGE: 'awaiting_back_image',
  PENDING: 'pending',
  PENDING_REVIEW: 'pending_review',
  REJECTED: 'rejected',
  CLEARING: 'clearing',
  SENT: 'sent',
  CANCELED: 'canceled',
  RETURNED: 'returned',
  AWAITING_CUSTOMER_CONFIRMATION: 'awaiting_customer_confirmation',
  PROCESSING: 'processing',
  NEEDS_REVIEW: 'needs_review'
};

export const checkDepositStatusOptions = [
  { key: 'all', name: 'All' },
  { key: CHECK_DEPOSIT_STATUS.SENT, name: 'Sent' },
  { key: CHECK_DEPOSIT_STATUS.REJECTED, name: 'Rejected' },
  { key: CHECK_DEPOSIT_STATUS.CANCELED, name: 'Canceled' },
  { key: CHECK_DEPOSIT_STATUS.CLEARING, name: 'Clearing' },
  { key: CHECK_DEPOSIT_STATUS.RETURNED, name: 'Returned' },
  { key: CHECK_DEPOSIT_STATUS.PROCESSING, name: 'Processing' },
  { key: CHECK_DEPOSIT_STATUS.NEEDS_REVIEW, name: 'Needs Review' }
];

export const PROCESSING_STATUSES = [
  CHECK_DEPOSIT_STATUS.PENDING,
  CHECK_DEPOSIT_STATUS.PENDING_REVIEW
];

export const NEEDS_REVIEW_STATUSES = [
  CHECK_DEPOSIT_STATUS.AWAITING_BACK_IMAGE,
  CHECK_DEPOSIT_STATUS.AWAITING_FRONT_IMAGE,
  CHECK_DEPOSIT_STATUS.AWAITING_IMAGES,
  CHECK_DEPOSIT_STATUS.AWAITING_CUSTOMER_CONFIRMATION
];

export const TRANSACTION_TYPE = {
  RECEIVED_ACH: 'Received ACH',
  SENT_ACH: 'Sent ACH',
  RETURNED_ACH: 'Returned ACH',
  RECEIVED_RETURNED_ACH: 'Received Returned ACH',
  RECEIVED_WIRE: 'Received Wire',
  SENT_WIRE: 'Sent Wire',
  RELEASE: 'Release'
};

export const TRANSACTION_TYPE_WITH_CHECKING_ACCOUNT = [
  TRANSACTION_TYPE.RECEIVED_ACH,
  TRANSACTION_TYPE.SENT_ACH,
  TRANSACTION_TYPE.RETURNED_ACH,
  TRANSACTION_TYPE.RECEIVED_RETURNED_ACH,
  TRANSACTION_TYPE.RECEIVED_WIRE,
  TRANSACTION_TYPE.SENT_WIRE,
  TRANSACTION_TYPE.RELEASE
];

export const CHECKING_ACCOUNT_HOLDER = 'Checking';

export const PAYMENT_TYPE = {
  ACH: 'ACH',
  WIRE: 'WIRE'
};

export const PAYMENT_TYPE_WITH_CHECKING_ACCOUNT = [PAYMENT_TYPE.ACH, PAYMENT_TYPE.WIRE];

export const MONEY_COLOR = {
  PRIMARY: 'primary',
  GREEN: 'green',
  TERTIARY: 'tertiary'
};

export const CHASE_BANK = 'Chase Bank';

export const INSTANT_FUNDING_TRANSFER_ROUTINE_STATUS = {
  ACTIVE: 'active',
  CANCELED: 'cancelled',
  COMPLETED: 'completed',
  FAILED: 'failed',
  INACTIVE: 'inactive',
  PENDING_ACCOUNT_AUTHORIZATION: 'pending_account_authorization',
  REQUIRES_USER_VERIFICATION: 'requires_user_verification',
  USER_SUSPENDED: 'user_suspended'
};
